import { Box, Grid, styled, Typography } from "@mui/material";
import React from "react";
import appcolors from "../../../constants/Colors";
import { allImages } from "../../../assets";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1100px",
  margin: "auto",
  padding: "16px",

  "& .lpl_rs_pr": {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "#161C2D",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  "& .lpl_rs_sr": {
    fontSize: "1.8rem",
    fontWeight: 600,
    color: "#161C2D",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    },
  },
}));

const joinSteps = [
  {
    step: 1,
    description: "Select services (Can select multiple services)",
  },
  {
    step: 2,
    description: "Set working staff member.",
  },
  {
    step: 3,
    description: "Set date and time for service.",
  },
];

function OnlineBooking() {
  const renderSteps = () => {
    return joinSteps?.map((val, ind) => {
      return (
        <Box mt={3} key={ind}>
          <Typography variant="h1" className="lpl_rs_sr">
            Step {val.step}
          </Typography>
          <Typography
            mt={1.5}
            fontWeight={300}
            variant="body1"
            color={"#161C2D"}
          >
            {val.description}{" "}
          </Typography>
        </Box>
      );
    });
  };
  return (
    <MainView my={{ xs: 3, md: 6 }}>
      <Grid container spacing={{ xs: 2, md: 4 }}>
        <Grid item xs={12} md={6}>
          <img
            src={allImages.landingMobileOnline}
            alt={"image"}
            width={"100%"}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h1" className="lpl_rs_pr">
            3- Online Booking
          </Typography>
          <Typography variant="h1" className="lpl_rs_pr">
            Best way to see spa & Salon
          </Typography>
          <Typography
            mt={1.5}
            fontWeight={300}
            variant="body1"
            color={"#161C2D"}
          >
            "Our app makes booking a breeze, displaying all available spa,
            salon, and B2B shops for easy selection. Browse detailed profiles,
            check available services, and book appointments with just a few
            taps. Enjoy a streamlined experience designed for your convenience."
          </Typography>

          {renderSteps()}
        </Grid>
      </Grid>
    </MainView>
  );
}

export default OnlineBooking;
